const vehicles = {
  table: {
    headers: {
      supplier: 'Fleets',
    },
    filters: {
      supplier: 'Fleet',
    },
  },

  form: {
    information: {
      details: {
        fields: {
          suppliers: 'Fleets',
        },
      },

      suppliers: {
        header: 'Fleets',
        fields: {
          suppliers: 'Fleets',
        },
      },
    },
  },
};

export default vehicles;
